import UiElement from "../../UiElement.js";

class BoxOverlayContent extends UiElement{
	constructor(config) {
		super(config);
		this.div = $('<div class="boxOverlay-content content_box_group"></div>');
		super.setBaseJQueryObject(this.div);
	}
}
export default BoxOverlayContent;